(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["consistency-tracker"]) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-routine-tracker]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';const key='psuche-consistency-v1';const boxes=[...root.querySelectorAll('[data-tracker-day]')];const status=root.querySelector('[data-tracker-progress]');const report=()=>{status.textContent=status.dataset.pattern.replace('COUNT',boxes.filter(b=>b.checked).length);};try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))boxes.forEach(b=>b.checked=saved.includes(b.dataset.trackerDay));}catch{root.querySelector('[data-tracker-storage]').hidden=false;}const save=()=>{try{localStorage.setItem(key,JSON.stringify(boxes.filter(b=>b.checked).map(b=>b.dataset.trackerDay)));}catch{root.querySelector('[data-tracker-storage]').hidden=false;}report();};boxes.forEach(b=>b.addEventListener('change',save));root.querySelector('[data-tracker-print]').addEventListener('click',()=>window.print());const clear=root.querySelector('[data-tracker-clear]');clear.addEventListener('click',()=>{if(window.confirm(clear.dataset.confirm)){boxes.forEach(b=>b.checked=false);save();}});report();});init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (window.psucheCartInitialized) return;
    window.psucheCartInitialized = true;
    const getDrawer = () => document.querySelector('[data-cart-drawer]');
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) getDrawer()?.showModal();
      if (event.target.closest('[data-cart-close]')) getDrawer()?.close();
    });
    document.addEventListener('psuche:cart_updated', async () => {
      try {
        const sectionId = document.querySelector('.site-header')?.dataset.sectionId;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Unable to refresh cart');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextHeader = parsed.querySelector('.site-header');
        const currentHeader = document.querySelector('.site-header');
        if (nextHeader && currentHeader) {
          currentHeader.replaceWith(nextHeader);
          getDrawer()?.showModal();
        } else {
          window.location.assign(window.Shopify.routes.root + 'cart');
        }
      } catch {
        window.location.assign('/cart');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["longevity-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-quiz-root]');
    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-quiz-form]');
      const result = root.querySelector('[data-quiz-result]');
      const resultsNode = root.querySelector('[data-quiz-results]');
      const error = root.querySelector('[data-quiz-error]');
      const restart = root.querySelector('[data-quiz-restart]');
      const results = JSON.parse(resultsNode.textContent);
      const emit = (name, detail = {}) => document.dispatchEvent(new CustomEvent(`psuche:${name}`, { detail }));
      emit('quiz_viewed', { version: '1.0' });
      form.addEventListener('change', () => emit('quiz_step_completed', { version: '1.0' }));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) {
          error.hidden = false;
          return;
        }
        error.hidden = true;
        const data = new FormData(form);
        let recommendation = 'complete';
        if (data.get('suitability') === 'yes') {
          recommendation = 'clinician';
        } else if (data.get('consistency') === 'support' || data.get('routine') === 'complex') {
          recommendation = 'reset';
        } else if (data.get('goal') === 'visible' && data.get('format') === 'single') {
          recommendation = 'collagen';
        } else if (data.get('goal') === 'foundation' || data.get('format') === 'pair') {
          recommendation = 'foundation';
        } else if (data.get('format') === 'complete' && data.get('consistency') !== 'steady') {
          recommendation = 'reset';
        }
        const selected = results[recommendation];
        result.querySelector('[data-result-title]').textContent = selected.title;
        result.querySelector('[data-result-text]').textContent = selected.text;
        result.querySelector('[data-result-supports]').textContent = selected.supports;
        result.querySelector('[data-result-link]').href = selected.url || '/collections/all';
        const resultTags = result.querySelector('[data-result-tags]');
        if (resultTags) resultTags.value = `quiz_completed,recommendation_${recommendation}`;
        form.hidden = true;
        result.hidden = false;
        result.focus();
        emit('quiz_completed', { version: '1.0', recommendation });
        emit('quiz_result_viewed', { version: '1.0', recommendation });
      });
      restart.addEventListener('click', () => {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        form.querySelector('input').focus();
        emit('quiz_started', { version: '1.0' });
      });
      form.addEventListener('focusin', () => {
        if (form.dataset.started !== 'true') {
          form.dataset.started = 'true';
          emit('quiz_started', { version: '1.0' });
        }
      }, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-product-form]');
      const variantSelect = root.querySelector('[data-variant-select]');
      const sellingPlanInput = root.querySelector('[data-selling-plan-input]');
      const price = root.querySelector('[data-product-price]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const submit = root.querySelector('[data-add-to-cart]');
      const mobileAdd = root.querySelector('[data-mobile-add]');
      const updateVariant = () => {
        const selected = variantSelect.tagName === 'SELECT' ? variantSelect.selectedOptions[0] : variantSelect;
        const variantId = selected.value;
        const available = selected.dataset.available !== 'false';
        root.querySelectorAll('[data-variant-purchase]').forEach((group) => {
          group.hidden = group.dataset.variantPurchase !== variantId;
        });
        const activeGroup = root.querySelector(`[data-variant-purchase="${variantId}"]`);
        const checked = activeGroup ? activeGroup.querySelector('[data-selling-plan-option]:checked') : null;
        if (sellingPlanInput) sellingPlanInput.value = checked ? checked.value : '';
        if (selected.dataset.price) {
          price.textContent = selected.dataset.price;
          mobilePrice.textContent = selected.dataset.price;
        }
        submit.disabled = !available;
        mobileAdd.disabled = !available;
      };
      variantSelect.addEventListener('change', updateVariant);
      root.querySelectorAll('[data-selling-plan-option]').forEach((option) => {
        option.addEventListener('change', () => {
          if (sellingPlanInput) sellingPlanInput.value = option.value;
          document.dispatchEvent(new CustomEvent('psuche:purchase_option_selected', { detail: { subscription: option.value !== '' } }));
        });
      });
      mobileAdd.addEventListener('click', () => submit.click());
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        submit.disabled = true;
        const originalText = submit.textContent;
        submit.textContent = form.dataset.addingMessage;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || form.dataset.errorMessage);
          document.dispatchEvent(new CustomEvent('psuche:add_to_cart', { detail: { source: 'product' } }));
          document.dispatchEvent(new CustomEvent('psuche:cart_updated'));
          root.querySelector('[data-product-status]').textContent = form.dataset.addedMessage;
        } catch (error) {
          root.querySelector('[data-product-status]').textContent = error.message || form.dataset.errorMessage;
        } finally {
          submit.disabled = false;
          submit.textContent = originalText;
        }
      });
      updateVariant();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
